import axios from 'axios';
import WebApi from '../WebApi';
import { AutoCompleteItemType, AutoCompletePayloadType, PlaceFormDataType } from '@/types/Address';

class AutocompleteWebApi extends WebApi {
    async getAddresses(address: any) {
        const { data } = await axios.post(`${this.urlPrefix}/ac_addresses`, { address });
        return data.addresses;
    }

    async getFrAddresses(address: AutoCompletePayloadType): Promise<Array<AutoCompleteItemType>> {
        const { data } = await axios.post(`${this.urlPrefix}/ac_fr_addresses`, { address });
        return data.addresses;
    }

    async fetchPlaceById(place: PlaceFormDataType) {
        const { data } = await axios.post(`${this.urlPrefix}/ac_addresses/fetch`, { place });
        return data.place;
    }
}

const autocompleteWebApi = new AutocompleteWebApi();

export {
    autocompleteWebApi as AutocompleteWebApi,
};
